import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import LegacyButton from "legacy/LegacyButton"
import ContractQuoteV2Actions from "legacy/contract-groups-v2/ContractQuoteV2Actions"
import { buildRoute, centsToDollars } from "legacy/helpers.es6"
import moment from "moment"
import PropTypes from "prop-types"
import React from "react"

import Badge from "src/components/Badge"
import { statusToken } from "src/components/Badge/status_tokens"

class ContractTableRowV2 extends ApplicationComponent {
  constructor(args) {
    super(args)

    this.state = {
      isSending: false,
    }

    this.markRowSending = this.markRowSending.bind(this)
  }

  markRowSending(isSending) {
    this.setState({ isSending })
  }

  dateFormat(updatedAt) {
    const date = moment(updatedAt)
    if (moment().format("YYYYMMDD") === date.format("YYYYMMDD")) {
      return "Today"
    } else if (
      moment().subtract(1, "days").format("YYYYMMDD") ===
      date.format("YYYYMMDD")
    ) {
      return "Yesterday"
    } else {
      return date.format("L")
    }
  }

  statusToIcon(status) {
    switch (status) {
      case "In House Only":
        return "person"
      case "Unsent":
      case "Sent":
        return "envelope-open"
      case "Boater Declined":
      case "Voided":
      case "Failed":
      case "Undeliverable":
      case "Canceled":
        return "circle-x"
      case "Completed In House":
      case "Signed":
        return "circle-check"
      default:
        return ""
    }
  }

  viewContact(contactId) {
    window.open(`${this.props.contactUrl}/${contactId}`, "_blank")
  }

  viewBoat(boatId, contactId) {
    window.open(
      `${this.props.contactUrl}/${contactId}/contact_boats/${boatId}/edit`,
      "_blank"
    )
  }

  renderLinksForContract(contract) {
    return (
      <ContractQuoteV2Actions
        quote={{
          encodedId: contract.encodedId,
          status: contract.status,
          hasGroup: true,
          withTemplate: contract.withTemplate,
        }}
        marina={{ name: this.props.marinaName, slug: this.props.marinaSlug }}
        updatePolicy={this.props.canUpdate}
        sendUrl={buildRoute(this.props.sendContractUrl, {
          group_id: contract.contractGroupId,
          quote_id: contract.encodedId,
        })}
        expireUrl={buildRoute(this.props.expireContractUrl, {
          group_id: contract.contractGroupId,
          quote_id: contract.encodedId,
        })}
        editUrl={buildRoute(this.props.editContractUrl, {
          group_id: contract.contractGroupId,
          quote_id: contract.encodedId,
        })}
        completeInHouseUrl={buildRoute(this.props.completeInHouseUrl, {
          group_id: contract.contractGroupId,
          quote_id: contract.encodedId,
        })}
        markContractDeclinedUrl={buildRoute(
          this.props.markContractDeclinedUrl,
          {
            group_id: contract.contractGroupId,
            quote_id: contract.encodedId,
          }
        )}
        deleteUrl={buildRoute(this.props.deleteContractUrl, {
          group_id: contract.contractGroupId,
          quote_id: contract.encodedId,
        })}
        reservationUrl={
          contract.reservationEncodedId
            ? buildRoute(this.props.reservationContractUrl, {
                reservation_id: contract.reservationEncodedId,
              })
            : null
        }
        generatePdfUrl={buildRoute(this.props.generatePdfEndpoint, {
          quote_id: contract.encodedId,
        })}
        savedPdfUrl={
          this.props.savedPdfEndpoint
            ? buildRoute(this.props.savedPdfEndpoint, {
                quote_id: contract.encodedId,
              })
            : null
        }
        updateSendContractFlash={this.props.updateSendContractFlash}
        markRowSending={this.markRowSending}
      />
    )
  }

  renderBadge() {
    const { status, viewedByBoaterText } = this.props.contract
    const badge = (
      <Badge
        color={statusToken(status)}
        icon={this.statusToIcon(status)}
        iconStyle="solid"
        text={this.state.isSending ? "Sending..." : status}
      />
    )

    if (status === "Sent" && viewedByBoaterText) {
      return (
        <div
          className="w-min"
          data-toggle="tooltip"
          data-placement="top"
          title={viewedByBoaterText}
        >
          {badge}
        </div>
      )
    }
    return badge
  }

  render() {
    return (
      <tr
        key={this.props.index}
        className={classNames({
          "bg-yellow-100":
            this.props.contract.encodedId === this.props.selectedContractId,
        })}
      >
        <td className="space-y-2 p-4">
          <div>
            <LegacyButton
              type="ghost"
              onClick={() =>
                this.viewContact(this.props.contract.contactEncodedId)
              }
            >
              {this.props.contract.customerName}
            </LegacyButton>
          </div>
          <div className="italic">
            <LegacyButton
              type="ghost"
              onClick={() =>
                this.viewBoat(
                  this.props.contract.contactBoatEncodedId,
                  this.props.contract.contactEncodedId
                )
              }
            >
              {this.props.contract.boatName}
            </LegacyButton>
          </div>
        </td>
        <td className="space-y-2 p-4">
          <div>{this.props.contract.rateText}</div>
          {!this.props.contract.monthToMonth && (
            <div>
              {centsToDollars(
                this.props.contract.total,
                2,
                this.props.currency
              )}{" "}
              total
            </div>
          )}
        </td>
        <td className="space-y-2 p-4">
          {this.renderBadge()}
          {this.props.contract.statusUpdatedAt && (
            <div>{this.dateFormat(this.props.contract.statusUpdatedAt)}</div>
          )}
        </td>
        <td className="shrink p-4">
          {this.renderLinksForContract(this.props.contract)}
        </td>
      </tr>
    )
  }
}

ContractTableRowV2.propTypes = {
  contract: PropTypes.shape({
    encodedId: PropTypes.string.isRequired,
    customerName: PropTypes.string,
    boatName: PropTypes.string,
    rateText: PropTypes.string,
    total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    monthToMonth: PropTypes.bool,
    status: PropTypes.string,
    statusUpdatedAt: PropTypes.string,
    viewedByBoaterText: PropTypes.string,
    contractGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    reservationEncodedId: PropTypes.string,
    withTemplate: PropTypes.bool,
    contactEncodedId: PropTypes.string,
    contactBoatEncodedId: PropTypes.string,
  }).isRequired,
  index: PropTypes.number,
  selectedContractId: PropTypes.string,
  canUpdate: PropTypes.bool,
  contactUrl: PropTypes.string,
  sendContractUrl: PropTypes.string,
  expireContractUrl: PropTypes.string,
  editContractUrl: PropTypes.string,
  completeInHouseUrl: PropTypes.string,
  markContractDeclinedUrl: PropTypes.string,
  deleteContractUrl: PropTypes.string,
  reservationContractUrl: PropTypes.string,
  generatePdfEndpoint: PropTypes.string,
  savedPdfEndpoint: PropTypes.string,
  marinaName: PropTypes.string,
  marinaSlug: PropTypes.string,
  updateSendContractFlash: PropTypes.func,
  currency: PropTypes.string,
}

export default ContractTableRowV2
